import {AfterViewInit,ChangeDetectionStrategy, Component,  ElementRef, OnDestroy, Input, OnInit, ViewChild} from '@angular/core';
import {Observable, from, Subscription} from "rxjs";
import {ActivatedRoute, Params} from '@angular/router';
//import {MaterialInstance, MaterialService} from "../../../classes/material.service";
import {PlaylistsService}  from "../../services/playlists.service";
 
import {switchMap, map, delay} from 'rxjs/operators'; 
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import { NbDialogService,NbGlobalPosition, NbToastrService } from '@nebular/theme';
import * as moment from 'moment';

@Component({
  selector: 'app-playlist-info',
  templateUrl: './playlist-info.component.html',
 // changeDetection: ChangeDetectionStrategy.OnPush,

  styleUrls: ['./playlist-info.component.scss'],
})
export class PlaylistInfoComponent implements OnInit, OnDestroy{
  

  @Input() playlist: any;
  @ViewChild('idetInfo') infoEdit:any ;
  
  infoForm: FormGroup
  dateAndTime:any = {
    date: new Date(),
    time: ''
  }

   constructor(public playlistsService:PlaylistsService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
    ){
}
 


  ngOnInit() {
    this.infoForm = new FormGroup({
      title: new FormControl(this.playlist.title, [Validators.required]),
      description: new FormControl(this.playlist.description)
    })


    //console.log()
  }



openEdit(){
	 
   
  this.dialogService.open(this.infoEdit,{hasScroll: true} )

}

openModal(content) {
  this.infoForm.patchValue({
    title: this.playlist.title,
    description: this.playlist.description

  }) 

  this.dialogService.open(content,{hasScroll: true} )

	
}

 

/*


  onFileUpload(event: any) {
    const file = event.target.files[0]
    this.image = file

    const reader = new FileReader()

    reader.readAsDataURL(file)
    reader.onload = () => {
      this.imagePreview = reader.result
    }
    reader.readAsDataURL(file)
  }


*/
 


updateCoverFileSub$: any = null
loadCover(fileInput){
  //console.log(fileInput.files.clear())

  const file = fileInput.files[0]

  this.updateCoverFileSub$ = this.playlistsService.updateCoverImage(this.playlist._id, file).subscribe(
    playlist=>{
      
     
     this.playlist.coverImage = playlist.coverImage
 
      
     this.toastrService.show('','Обкладинка завантажена' , {
       status: 'success',
       position: <NbGlobalPosition>'bottom-right'
     })
    
   },error =>{ 
    // MaterialService.toast(error.error.message)
     this.toastrService.show('' ,'Обкладинка не завантажена' ,{
      status: 'danger',
	position: <NbGlobalPosition>'bottom-right'
    })
   } 
 )

}


deleteCoverFileSub$ = null
deleteCover(){
  this.deleteCoverFileSub$ = this.playlistsService.deleteCoverImage(this.playlist._id).subscribe(
    playlist=>{
         
     
     this.playlist.coverImage = playlist.coverImage
  

     this.toastrService.show('','Обкладинка видалена',{
      status: 'success',
	position: <NbGlobalPosition>'bottom-right'
    })
   
   },error =>{ 
     //MaterialService.toast(error.error.message)
     this.toastrService.show('','Не вдалося видалити обкладинку',{
      status: 'danger',
	position: <NbGlobalPosition>'bottom-right'
    })
   } 
 )


}




updateInfoSub$: any = null
submitInfoForm(modal:any){
   modal.close()

   this.infoForm.disable()

    

   this.updateInfoSub$ = this.playlistsService.updateInfo(this.playlist._id,this.infoForm.value.title, this.infoForm.value.description ).subscribe(
     playlist=>{
       
      
      this.playlist.title = playlist.title

      this.playlist.description = playlist.description
     

     this.toastrService.show('','Інформація збережена',{
      status: 'success',
      position: <NbGlobalPosition>'bottom-right'
        })
 
    },error =>{ 
     // MaterialService.toast(error.error.message)
      this.toastrService.show('','Інформація не збережена',{
        status: 'danger',
        position: <NbGlobalPosition>'bottom-right'
        })
    },
    ()=>{
      this.infoForm.enable()
    }
  )


}

  
  ngOnDestroy() {
    if(this.updateInfoSub$){
      this.updateInfoSub$.unsubscribe()
    }
 
    if(this.updateCoverFileSub$){
      this.updateCoverFileSub$.unsubscribe()
    }

    
    if(this.deleteCoverFileSub$){
      this.deleteCoverFileSub$.unsubscribe()
    }


   }
  
}
